module.exports = __webpack_public_path__ + "img/titulo-chile-en-spotify.f194decd.png";